import { Form, Formik } from 'formik';
import { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '../../components/Button';
import ButtonBack from '../../components/ButtonBack';
import { FormGroup } from '../../components/Form';
import Input from '../../components/Form/Input';
import PasswordRules from '../../components/PasswordRules';
import Spacing from '../../components/Spacing';
import { SupportText } from '../../components/Support';
import Text from '../../components/Text';
import schemaPassword from '../../utils/schemas/password';
import { Container, OutlinedInputContainer } from './styles';
import ErrorMessage from '../../components/Form/ErrorMessage';
import { logout, resetPassword, validatePasswordCode } from '../../services/user';
import Loading from '../../components/Loading';
import ErrorBox from '../../components/ErrorBox';
import Modal from './components/Modal';
import m from '../../utils/messages';

const Main = () => {

  const history = useHistory();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const credentials = useSelector(state => state.main.credentials);

  const [passwordCriteria, setPasswordCriteria] = useState({
    uppercase: false,
    lowercase: false,
    number: false,
    length: false
  });

  const ref = useRef(null); // Create a reference for the Formik component

  const validateCode = async (code) => {
    try {
      const { token } = await validatePasswordCode({ 
        [credentials.field]: credentials.value,  
      }, code);
      return token;
    } catch (err) {
      switch(err.code) {
        case "invalidCode":
          setError('Código inválido');
          return;          
        default:
          setError(m('internalError'));
          return;
      }
    }
  }

  const handleSubmit = async (formData, { setSubmitting, isSubmitting }) => {
    if(isSubmitting || success) {
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await logout();
    } catch {}
    
    try {
      const token = await validateCode(formData.code);

      if (token) {
        const data = await resetPassword(formData, token);
        setSuccess(true);
        window.location.href = data?.redirectTo;
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        history.replace('/login');
      } else if(err?.response?.data?.message) {
        setError(err?.response?.data?.message);
      } else {
        setError(m('internalError'));
      }
    }
    setSubmitting(false);
  }
  
  const handlePasswordChange = (e) => {
    const value = ref.current.values.password; // Access the password value using the ref

    setPasswordCriteria({
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      length: value.length >= 8
    });
  };
  
  return (
    <Container>
      {success && <Loading position="fixed" />}
      <Text variant="regular">Informe o Código de Acesso enviado para o seu e-mail e crie uma nova senha:</Text>
      <Spacing size={24} />
      <ErrorBox error={error} />
      <Formik 
        initialValues={{ code: '', password: '', password_confirmation: '' }} 
        validationSchema={schemaPassword} 
        validateOnMount
        onSubmit={handleSubmit}
        innerRef={ref} // Pass the ref to the Formik component
      >
        {({ isSubmitting, isValid }) => (
          <Form className="login__form form">
            <OutlinedInputContainer>
              <Input variant="outlined" name="code" required />
            </OutlinedInputContainer>
            <FormGroup>
              <Input name="password" type="password" label="Cria uma senha" onKeyUp={handlePasswordChange} />
              <ErrorMessage name="password" />
            </FormGroup>
            <Spacing size={24} />
            <FormGroup>
              <Input name="password_confirmation" type="password" label="Confirme sua senha" />
              <ErrorMessage name="password_confirmation" />
            </FormGroup>
            <Spacing size={40} />
            <PasswordRules rules={passwordCriteria} />
            <Button variant="buttonPrimary" text="Cadastrar" type="submit" disabled={!isValid} loading={isSubmitting} />
          </Form>
        )}
      </Formik>
      <SupportText />
    </Container>
  )
}

const PasswordForgot = () => {
  const [modalOk, setModalOk] = useState(false);
  const history = useHistory();
  
  return (
    <>
      <ButtonBack onClick={() => history.goBack()} />
      {modalOk ? (
        <Main />
      ) : (
        <Modal onConfirm={() => setModalOk(true)} />
      )} 
    </>
  );
}

export default PasswordForgot;
